import React from 'react';
import { Home, Clock, GraduationCap, BadgeCheck, Globe } from 'lucide-react';

const strengthData = [
  {
    icon: Home,
    title: "Agriculture Family Background",
    description: "We are the team, who bore and brought up in agriculture family with Solid fundamental in agriculture."
  },
  {
    icon: Clock,
    title: "2 Decades of Experience",
    description: "We spend 2 decades in Agriculture; We know the pros and cons in this field."
  },
  {
    icon: GraduationCap,
    title: "Professional Qualifications",
    description: "Graduated of Engineering and Medicine with international exposure"
  },
  {
    icon: BadgeCheck,
    title: "Trust First Approach",
    description: "Trust is our first priority in all our relationships"
  }, 
  {
    icon: Globe,
    title: "International Exposure",
    description: "Exposure to international projects and global standards enables us to deliver high-quality, technology-driven, and scalable solutions aligned with worldwide best practices."
  },

];

const OurStrength = () => {
  // Shared accent color with MissionVision
  const accentColor = "#Cca32a";
  const darkGreen = "#1a4d2e";

  return (
    <section className="strength-section">
      <div className="strength-container">

        {/* Main Header Title (Same style as Mission/Vision) */}
        <div className="mv-header">
          <h2 className="mv-title">Our Strength</h2>
          <div className="mv-underline" style={{ backgroundColor: accentColor }}></div>
        </div>

        <div className="strength-content-wrapper">

          {/* Left Column: Why Choose Us & Quote */}
          <div className="strength-left-col">
            <h3 className="left-col-title">Why Choose GK Agro Machinery?</h3>

            <p className="description-text">
              With deep roots in agriculture and decades of experience, we understand the unique challenges and opportunities in modern farming. Our team combines traditional knowledge with modern technology to provide the best solutions for farmers.
            </p>

            {/* Tamil Quote Block */}
            <div className="quote-block">
              <h4 className="quote-heading">Tamil Thirukkural Quote</h4>
              <blockquote className="tamil-quote">
                உழுதுண்டு வாழ்வாரே வாழ்வார்மற் றெல்லாம்<br />
                தொழுதுண்டு பின்செல் பவர்
              </blockquote>
              <p className="quote-meaning">
                Meaning: The wise who can control themselves will control the world; others who cannot control themselves will not attain such greatness.
              </p>
            </div>
          </div>

          {/* Right Column: Strength Cards */}
          <div className="strength-right-col">
            {strengthData.map((item, index) => {
              const IconComponent = item.icon;
              return (
                <div key={index} className="strength-card">
                  <div className="strength-icon-box">
                    <IconComponent size={32} color={accentColor} strokeWidth={2} />
                  </div>
                  <div className="strength-text-content">
                    <h4 className="strength-card-title">{item.title}</h4>
                    <p className="strength-card-desc">{item.description}</p>
                  </div>
                </div>
              );
            })}
          </div>

        </div>
      </div>

      <style>{`
        /* General Setup - Consistent with MissionVision */
        .strength-section {
          background-color: #ffffff; /* White background for contrast */
          padding: 4rem 1.5rem;
          font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
        }
        .strength-container {
          max-width: 1200px;
          margin: 0 auto;
        }

        /* Reused Header Styles from MissionVision */
        .mv-header {
          text-align: center;
          margin-bottom: 3.5rem;
        }
        .mv-title {
          font-size: 2.5rem;
          color: ${darkGreen}; /* Dark Forest Green */
          margin-bottom: 0.5rem;
          font-weight: 600;
        }
        .mv-underline {
          width: 80px;
          height: 4px;
          margin: 0 auto;
          border-radius: 2px;
        }
        
        /* Main Two-Column Layout */
        .strength-content-wrapper {
          display: grid;
          grid-template-columns: 1fr;
          gap: 3rem;
          align-items: flex-start; /* Aligns content to the top */
        }
        @media (min-width: 900px) {
          .strength-content-wrapper {
            grid-template-columns: 1.5fr 1fr; /* Left column slightly wider */
            gap: 4rem;
          }
        }

        /* Left Column Styling */
        .strength-left-col {
          padding: 2rem 0;
        }
        .left-col-title {
          font-size: 1.8rem;
          color: ${darkGreen};
          font-weight: 700;
          margin-bottom: 1.5rem;
        }
        .description-text {
          font-size: 1rem;
          line-height: 1.7;
          color: #4b5563;
          margin-bottom: 2.5rem;
        }

        /* Quote Block Styling */
        .quote-block {
          background-color: #f9fafb; /* Light background for the quote */
          border-left: 5px solid ${accentColor}; /* Gold accent bar */
          padding: 1.5rem;
          border-radius: 8px;
        }
        .quote-heading {
          font-size: 0.9rem;
          color: ${darkGreen};
          text-transform: uppercase;
          margin-bottom: 0.5rem;
          font-weight: 600;
        }
        .tamil-quote {
          font-style: italic;
          font-size: 1.1rem;
          color: #111827;
          margin-bottom: 0.8rem;
        }
        .quote-meaning {
          font-size: 0.9rem;
          color: #6b7280;
        }

        /* Right Column: Strength Cards */
        .strength-right-col {
          display: flex;
          flex-direction: column;
          gap: 1rem;
        }

        .strength-card {
          display: flex;
          align-items: center;
          background: #ffffff;
          padding: 1.25rem;
          border-radius: 8px;
          border: 1px solid #e5e7eb;
          box-shadow: 0 4px 10px rgba(0, 0, 0, 0.03);
          transition: border-color 0.3s ease;
        }
        
        .strength-card:hover {
            border-color: ${accentColor};
        }

        .strength-icon-box {
          flex-shrink: 0; /* Prevents icon from shrinking */
          padding: 10px;
          background-color: #fffbeb; /* Very light yellow/gold background */
          border-radius: 6px;
          margin-right: 1rem;
          display: flex;
          align-items: center;
          justify-content: center;
        }

        .strength-card-title {
          font-size: 1rem;
          font-weight: 600;
          color: ${darkGreen};
          margin-bottom: 0.25rem;
        }

        .strength-card-desc {
          font-size: 0.9rem;
          color: #6b7280;
          line-height: 1.4;
        }
      `}</style>
    </section>
  );
};

export default OurStrength;